import BigNumber from 'bignumber.js';
import { Address } from 'viem';

export const MAIN_TOKEN_ADDRESS: Address = import.meta.env
  .VITE_MAIN_TOKEN_ADDRESS;
export const LIQUID_STAKING_TOKEN_ADDRESS: Address = import.meta.env
  .VITE_LIQUID_STAKING_TOKEN_ADDRESS;

// eslint-disable-next-line prefer-destructuring
export const DEPRECATED_LIQUID_STAKING_TOKEN_ADDRESS: Address = import.meta.env
  .VITE_DEPRECATED_LIQUID_STAKING_TOKEN_ADDRESS;

export const EXPLORER_LINK: string = import.meta.env.VITE_EXPLORER_LINK;

export const IPFS_PREFIX = 'ipfs://';

// Base gateway URL. Dedicated BFF endpoints hang off it directly
// (e.g. the Pinata upload proxy `/pinata/pin-file`).
export const BFF_BASE_URL: string =
  import.meta.env.VITE_BFF_API_URL ||
  'https://matchainbff.staking.ankr.network';

// Generic caching proxy endpoint (`?url=` forwarding).
export const BFF_API_URL = `${BFF_BASE_URL}/proxy`;

export const POOLS_LIMIT = 21;

export const AVG_SECONDS_IN_YEAR = new BigNumber(31556736);

export const TOKENS_YEAR = AVG_SECONDS_IN_YEAR.div(3);

export const BLOCKS_PER_SECOND = 4;

export const SECONDS_IN_DAY = 86400;
